import { render, staticRenderFns } from "./ListaAtividadeDisciplinaCompetencia.vue?vue&type=template&id=1a3fa509"
import script from "./ListaAtividadeDisciplinaCompetencia.vue?vue&type=script&lang=js"
export * from "./ListaAtividadeDisciplinaCompetencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports